import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Fish, Map, Package, IdCard, Menu, X, BookOpen } from "lucide-react";

const links = [
  { to: "/spots", label: "Carte des Spots", icon: Map },
  { to: "/equipement", label: "Équipement & Kits", icon: Package },
  { to: "/carnet", label: "Mon carnet", icon: BookOpen },
  { to: "/carte-de-peche", label: "Carte de Pêche", icon: IdCard },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-[900] backdrop-blur-md bg-white/85 border-b border-emerald-900/10">
      <nav className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span className="grid place-items-center w-9 h-9 rounded-xl bg-emerald-800 text-white group-hover:bg-emerald-900 transition-colors">
            <Fish className="w-5 h-5" />
          </span>
          <span className="font-display font-extrabold text-lg tracking-tight text-emerald-950">
            PêcheSpot<span className="text-emerald-600"> France</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {links.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={`nav-${to.replace("/", "")}`}
              className={({ isActive }) =>
                `flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                  isActive
                    ? "bg-emerald-100 text-emerald-900"
                    : "text-emerald-800/80 hover:bg-emerald-50 hover:text-emerald-900"
                }`
              }
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
          <a
            href="https://www.cartedepeche.fr"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-buy-license"
            className="ml-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold py-2 px-5 rounded-full shadow-md transition-all hover:-translate-y-0.5"
          >
            Acheter ma carte
          </a>
        </div>

        <button
          className="md:hidden p-2 text-emerald-900"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-emerald-900/10 bg-white px-4 py-3 space-y-1">
          {links.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-semibold ${
                  isActive ? "bg-emerald-100 text-emerald-900" : "text-emerald-800"
                }`
              }
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
          <a
            href="https://www.cartedepeche.fr"
            target="_blank"
            rel="noopener noreferrer"
            className="block text-center bg-amber-600 text-white font-semibold py-3 rounded-xl"
          >
            Acheter ma carte
          </a>
        </div>
      )}
    </header>
  );
}
